import React, { useState } from 'react';

// project-imports
import { useTestimonialContext } from '../../context/testimonial_context';
import Spinner from '../spinner-component/SpinnerOne';
import SectionTitle from '../sectionTitle/SectionTitle';
import ErrorComponent from '../error-message/ErrorComponent';
import TestimonialReactJs from '../testimonial/TestimonialReactJs'

// third-party
import ScrollAnimation from 'react-animate-on-scroll';

const TestimonialSectionReactJs = ({ courseDomain }) => {

    // reading data from Context
    const { testimonialLoading, testimonials: data, testimonialError } = useTestimonialContext();

    // Constant variable 
    const testimonials = Array.isArray(data) ? data : [];

    // State variable initialization 
    const [isLoading, setIsLoading] = useState(true);

    // Loading timeout 
    setTimeout(() => {
        setIsLoading(false);
    }, 1000)

    return (
        <div className="eduvibe-home-four-testimonial edu-testimonial-area edu-section-gap bg-color-white">
            <div className="container eduvibe-animated-shape mb--80">

                {/* Loading spinner */}
                {(testimonialLoading || isLoading) &&
                    <div className="row g-5 mt--25 text-center">
                        <div className="col-lg-12">
                            <Spinner />
                        </div>
                    </div>
                }

                {/* Error handling */}
                {Boolean(testimonialError && !testimonialLoading) &&
                    <div className="row g-5 mt--25 text-center">
                        <div className="col-lg-12 col-12 inner">
                            {/* Error component 500 */}
                            <ErrorComponent errorCode="500" mainError="Failed to get the Testimonials Data." />
                        </div>
                    </div>
                }
                {Boolean(!testimonialLoading && !testimonialError && ((testimonials && !testimonials.length) || !testimonials)) &&
                    <div className="col-lg-12">
                        <div className="testimonial-wrapper ">
                            <SectionTitle
                                classes="text-center mb--40"
                                slogan={(courseDomain && courseDomain === "All") ? "All Testimonial" : "ReactJS Testimonial"}
                                title="Our Students Feedback"
                            />
                        </div>
                    </div>
                }

                {/* Error handling */}
                {Boolean(!testimonialLoading && !testimonialError && ((testimonials && !testimonials.length) || !testimonials)) &&
                    <div className="row g-5 mt--25 text-center">
                        <div className="col-lg-12 col-12 inner">
                            {/* Error component 404 */}
                            <ErrorComponent errorCode="404" mainError="Oops...! No Testimonials are available." />
                        </div>
                    </div>
                }
                {Boolean(!testimonialLoading && !testimonialError && testimonials && testimonials.length) &&
                    <div className="row">
                        <div className="col-lg-6">
                            <ScrollAnimation
                                animateIn="fadeIn"
                                animateOut="fadeInOut"
                                className="testimonial-left-image pr--80"
                                animateOnce={true}
                            >
                                {Boolean(!testimonialError && !testimonialLoading && testimonials && testimonials.length) &&
                                    <div className="thumbnail">
                                        <div className="circle-image-wrapper">
                                            <img className="radius-round" src="/images/testimonial-section/client-banner-left.jpg" alt="Testimonial Section Thumb" />
                                            <div className="circle-image">
                                                <span></span>
                                                <span></span>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </ScrollAnimation>
                        </div>
                        <div className="col-lg-6">
                            <div className="testimonial-wrapper">
                                <SectionTitle
                                    classes="text-start mb--40"
                                    slogan={(courseDomain && courseDomain === "All") ? "All Testimonial" : "ReactJS Testimonial"}
                                    title="Our Students Feedback"
                                />
                                <TestimonialReactJs courseDomain={courseDomain} item={Array.isArray(testimonials) && testimonials.length} />
                            </div>
                        </div>
                    </div>
                }
                <div className="shape-dot-wrapper shape-wrapper d-xxl-block d-none">
                    <div className="shape-image shape-image-1">
                        <img src="/images/shapes/shape-01-02.png" alt="Shape Thumb" />
                    </div>
                    <div className="shape-image shape-image-2">
                        <img src="/images/shapes/shape-25-01.png" alt="Shape Thumb" />
                    </div>
                    <div className="shape-image shape-image-3">
                        <img src="/images/shapes/shape-11-04.png" alt="Shape Thumb" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TestimonialSectionReactJs;